<template>
  <div class="wrapper sign-in-wrapper">
    <div class="redirectCls" v-if="redirect">
      <h1>{{ t("redirect") }}</h1>
    </div>
    <div v-else>
      <h2>{{ t("signin") }}</h2>
      <div class="register">
        <div id="overlay" :style="{ display: overlayDisplay }">
          <div id="text">
            <loader />
          </div>
        </div>
        <div>
          <form @submit.prevent="submit">
            <div>

              <wb-input class="mt-20" v-bind:readonly="isReadOnly" type="email" name="email" v-model="form.email" @blur="validateEmail" v-on:keyup="emailChange" id="emailId">
                <span slot="label">{{ t("emailplaceholder") }}</span>
                <wb-control-error v-if="emailEmptyError" slot="message">
                  {{ t("emptyEmail") }}
                </wb-control-error>
                <wb-control-error v-if="qrCodeExpiryError" slot="message">
                  {{ t("qrcodeError") }}
                </wb-control-error>
                <wb-control-error v-if="emailNotValidError" slot="message">
                  {{ t("incorrectEmail") }}
                  {{ providerResponse }}
                </wb-control-error>
                <wb-control-error v-if="otherDomainError" slot="message">
                  {{ t("unidentifiedProviderError") }}
                </wb-control-error>
              </wb-input>
              <!-- <input v-if="showSubmit" v-on:click="validateEmailInForm" type="submit"
              :value="t('next')" /> -->
              <wb-button class="mt-20" v-if="showSubmit" v-on:click="validateEmailInForm" size="m" type="submit" variant="primary">
                {{ t("next") }}
              </wb-button>
            </div>
            <div v-if="emailValidated"> <!-- v-if="emailValidated" -->
              <wb-input type="password" class="mt-20" name="password" id="password" v-model="pwd" :value="pwd" ref="passwordInput" @input="passwordChange" special-action-label="Toggle password visibility">
                <span slot="label">{{ t(this.placeHolder) }}</span>
                <wb-control-error v-if="pwdCalEmptyError" slot="message">
                  {{ t("emptyCalPassword") }}
                  {{ providerResponse }}</wb-control-error>
              </wb-input>
              <div v-if="showCalPassword">
                <wb-input
                    type="password"
                    class="mt-20"
                    name="calPassword"
                    id="calPassword"
                    v-model="calpwd" :value="calpwd" ref="passwordInput"
                    @input="calendarPasswordChange"
                    special-action-label="Toggle password visibility"
                >
                  <span slot="label">{{ t("calpasswordplaceholder") }}</span>
                  <wb-control-error v-if="pwdCalEmptyError" slot="message"
                  >{{ t("emptyCalPassword") }}
                    {{ providerResponse }}</wb-control-error
                  >
                </wb-input>
              </div>
              <div>
                <moreDetails />
              </div>
              <div class="btnsPrntDiv">
                <div>
                  <wb-button class="mt-20" v-if="showFinalSubmit" v-on:click="backToEmailPage" type="button" size="m" variant="primary">
                    {{ t("back") }}
                  </wb-button>
                </div>
                <div class="ml-10">
                  <wb-button class="mt-20" v-bind:disabled="disableSubmitButton" v-if="showFinalSubmit"  v-on:click="validatePassword" type="submit" size="m" variant="primary">
                    {{ t("submit") }}
                  </wb-button>
                </div>
              </div>
            </div>
            <div class="mb-20">
              <p v-if="showSubmitError"  id="error">
                {{ t(this.submitError) }}
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useI18n } from "vue-i18n";
import axios from "axios";
import loader from "../components/LoaderAnimation.vue";
import moreDetails from "./MoreDetails.vue";
import JSEncrypt from "jsencrypt";
export default {
  name: "SignIn",
  components: {
    loader,
    moreDetails,
  },
  setup() {
    const { t, locale,} = useI18n();
    return {
      t,
      locale,
    };
  }
  ,
  data() {
    return {
      redirect: false,
      overlayDisplay: "none",
      providerResponse: "",
      handle: "",
      ciam: "",
      expiry: "",
      lang: "en",
      form: {
        email: "",
        password: "",
        calPassword: ""
      },
      showError: false,
      submitError: "",
      showSubmitError: false,
      emailValidated: false,
      domainValidated: false,
      emailNotValidError: false,
      emailEmptyError: false,
      errorMessage: "",
      showSubmit: true,
      showCalPassword: false,
      showFinalSubmit: false,
      isReadOnly: false,
      oldEmailEntered: "",
      disableSubmitButton : true,
      changePassword: false,
      changeCalendarPassword: false,
      messageCode: "",
      qrCodeExpiryError : false,
      signinKey: "",
      InCar: false,
      placeHolder : "",
      Headunit: "",
      pwd: "",
      calpwd:"",
      isOthersDomain: false,
      otherDomainError: false,
      cod: ""
    };
  },

  trimlocale(loc) {
    return loc.split('-')[0];
  },
  mounted() {
    this.handle = this.$route.query.handle;
    this.expiry = this.$route.query.expiry;
    this.ciam = this.$route.query.ciam;
    this.fin = this.$route.query.fin;
    this.locale = this.$route.query.locale;
    this.cod = this.$route.query.cod;
    this.hu = this.$route.query.hu.replaceAll("\\","");
    if (this.hu === "3") {
      this.InCar = true;
      this.placeHolder = "calpasswordplaceholder"
    }else {
      this.placeHolder = "passwordplaceholder"
    }
  },
  methods: {
    callOverlayToggle() {
      if (this.overlayDisplay == "block") {
        this.overlayDisplay = "none";
      } else {
        this.overlayDisplay = "block";
      }
    },
    getProviderConfig() {
      let config = {
        crossDomain: true,
        mode: "no-cors",
        headers: this.getAuthParam(),
      };
      config.headers.Mail = this.form.email;
      config.headers.locale = this.locale;
      config.headers.Headunit = this.hu;
      return config;
    },
    getAuthParam() {
      return {
        expiry: this.expiry,
        fin: this.fin,
        ciam: this.ciam,
        handle: this.handle,
        locale: this.locale,
        cod: this.cod,
      };
    },
    callProvider(mailId)
    {
      this.showError = false;
      this.isReadOnly = false; //true;
      this.callOverlayToggle();
      var outer = this;
      let emailProvider = outer.form.email.split('@')[1].toUpperCase();
      if(emailProvider.includes("T-ONLINE")) {
        this.showCalPassword = true;
        this.InCar = true;
      }
      let body = this.getAuthParam();
      body.mailId = mailId;
      body.locale = this.locale;
      body.hu = this.hu;
      body.cod = this.cod;
      axios
          .post("/api/provider", body, this.getProviderConfig())
          .then(function (response)
          {
            outer.callOverlayToggle();
            outer.showSubmitError = false;
            outer.submitError = "";
            if (response.headers && response.headers.location) {
              outer.redirect = true;
              window.location.href = response.headers.location;
              document.addEventListener("visibilitychange", () => {
                outer.redirect=false;
              });
            } else {
              let emailDomain = outer.form.email.split('@')[1].toUpperCase();
              // outer.domainValidated = emailDomain ? true : false;
              var locDomain= localStorage.getItem("emailDomain")
              if(locDomain.includes("OTHERS")){
                outer.isOthersDomain=true;
              }

              if(emailDomain.includes("YAHOO")) {
                localStorage.setItem("emailDomain", "YAHOO");
              } else if(emailDomain.includes("WEB.DE")) {
                localStorage.setItem("emailDomain", "WEB.DE")
              } else if(emailDomain.includes("ZOHO")) {
                localStorage.setItem("emailDomain", "ZOHO")
              } else if(emailDomain.includes("GMX")) {
                localStorage.setItem("emailDomain", "GMX")
              } else if(emailDomain.includes("ICLOUD") || emailDomain.includes("ME")){
                localStorage.setItem("emailDomain","ICLOUD")
              }else if(emailDomain.includes("T-ONLINE")) {
                localStorage.setItem("emailDomain", "T-ONLINE")
              }

              outer.emailValidated = true;
              outer.showSubmit = false;
              outer.showFinalSubmit = true;
              outer.isReadOnly = true;
            }
          })
          .catch(function (response) {
            outer.callOverlayToggle();
            if (
                response &&
                response.response &&
                response.response.data &&
                response.response.data.message &&
                response.response.data.messageCode
            ) {
              outer.showSubmitError = true;
              outer.submitError = response.response.data.messageCode ;

            }
          });
    },
    backToEmailPage()
    {
      this.showError = false;
      this.emailValidated = false;
      this.showSubmit = true;
      this.showFinalSubmit = false;
      this.isReadOnly = false;
      this.emailNotValidError = false;
      this.emailEmptyError = false;
      this.submitError = "";
      this.disableSubmitButton = true;
      this.pwd="";
      this.calpwd="";
      if(this.isOthersDomain == true){
        localStorage.setItem("emailDomain","OTHERS");
      }
      //location.reload(true);
      this.$router.push({path:'/sign-in', query: this.$route.query});
    },
    passwordChange(event)
    {
      //let updatePassword= this.$refs.passwordInput.value;
      let updatePassword= event.target.value;
      this.PasswordValue = updatePassword
      if(updatePassword && updatePassword.length > 0) {
        this.changePassword = true
      } else {
        this.changePassword = false
      }

      if(this.showCalPassword === true && this.changePassword == true && this.changeCalendarPassword == true  || this.InCar === true) {
        this.disableSubmitButton = false;
      } else if(this.showCalPassword !== true && this.changePassword == true || this.InCar === true  ) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    },
    calendarPasswordChange(event)
    {
     // let updateCalPassword= this.$refs.calPasswordInput.value
      let updateCalPassword= event.target.value
      this.calPasswordValue = updateCalPassword
      if(updateCalPassword && updateCalPassword.length > 0) {
        this.changeCalendarPassword = true
      } else {
        this.changeCalendarPassword = false
      }

      if(this.showCalPassword === true && this.changePassword == true && this.changeCalendarPassword == true) {
        this.disableSubmitButton = false;
      } else if(this.showCalPassword !== true && this.changePassword == true) {
        this.disableSubmitButton = false;
      } else {
        this.disableSubmitButton = true;
      }
    },
    validateEmailInForm()
    {
      if (this.validateEmail())
      {
        this.emailNotValidError = false;
        this.emailEmptyError = false;
        const pubKeyBase64 = this.$cookies.get("casPubKey");
        if (pubKeyBase64) {
          let buff = new Buffer(pubKeyBase64, 'base64');
          let pubKey = buff.toString('ascii');
          let encryptObj = new JSEncrypt({default_key_size: 2048})
          encryptObj.setPublicKey(pubKey);
          let encryptedMail = encryptObj.encrypt(this.form.email);
          this.callProvider(encryptedMail);
        } else {
          this.qrCodeExpiryError = true;
          this.showError = true;
          this.submitError = "qrcodeError";
          this.emailValidated = false;
          this.domainValidated = false;
          this.showSubmit = true;
          this.showFinalSubmit = false;
          this.isReadOnly = false;
        }
      } else {
        this.showError = true;
        this.emailValidated = false;
        this.domainValidated = false;
        this.showSubmit = true;
        this.showFinalSubmit = false;
        this.isReadOnly = false;
        if(this.form.email == undefined || this.form.email == "") {
          this.emailEmptyError = true;
          this.emailNotValidError = false;
        } else if(this.otherDomainError == true){
          this.emailEmptyError = false;
          this.emailNotValidError = false;
        } else {
          this.emailEmptyError = false;
          this.emailNotValidError = true;
        }
      }
    },
    validatePassword()
    {
      if(this.showCalPassword === true) {
        // here we need to get both passwords.
        this.form.password = document.getElementById("password").value;
        this.form.calPassword = document.getElementById("calPassword").value;
        if (this.form.password !== undefined && this.form.calPassword !== undefined && this.form.password.length>0 && this.form.calPassword.length>0) {
          this.callSignup();
          return;
        }
      } else {
        this.form.password = document.getElementById("password").value;
       // this.form.password="";
        this.callSignup();
      }
    },
    callSignup() {
      const pubKeyBase64 = this.$cookies.get("casPubKey");
      if (pubKeyBase64) {
        let buff = new Buffer(pubKeyBase64, 'base64');
        let pubKey = buff.toString('ascii');
        let encryptObj = new JSEncrypt({default_key_size: 2048})
        encryptObj.setPublicKey(pubKey);
        let body =
            {
              user_email: "",
              password: "",
              calPassword: "",
              locale: ""
            };
        let outer = this;
        let config =
            {
              headers: this.getAuthParam(),
            };
        outer.callOverlayToggle();
        let encryptedEmail = encryptObj.encrypt(this.form.email);
        let encryptedPassword = encryptObj.encrypt(this.form.password);
        let encryptedCalPassword = encryptObj.encrypt(this.form.calPassword);
        body.user_email = encryptedEmail
        body.password = encryptedPassword
        body.calPassword = encryptedCalPassword
        body.locale = this.locale
        axios
            .post("/api/signup", body, config)
            .then(function () {
              outer.callOverlayToggle();
              outer.showSubmitError = false;
              outer.$router.push({name: "connected"});
            }).catch(function (response) {
          outer.callOverlayToggle();
          if (
              response &&
              response.response &&
              response.response.data &&
              response.response.data.error &&
              response.response.data.messageCode
          ) {
            if (response.response.data.messageCode === 'duplicate_account') {
            // Redirect to the "error" page only if it's a duplicate account error
            outer.$router.push({ name: "duplicate-account" }); // Replace "error" with the actual route name you want
          }
            outer.showSubmitError = true;
            outer.submitError = response.response.data.messageCode;
          }
        });
      } else {
        let outer = this;
        outer.showSubmitError = true;
        outer.submitError = "qrcodeError"
      }
    },
    validateEmail() {
      this.form.email = document.getElementById("emailId")?.value;
      this.oldEmailEntered = this.form.email;
      this.otherDomainError= false;

      var localDomain= localStorage.getItem("emailDomain");
      var receivedMail= document.getElementById("emailId")?.value;
      console.log("localDomain: "+localDomain);
      console.log("email: "+this.form.email);

      var validRegex =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(this.form.email == undefined || this.form.email == "") {
        this.emailEmptyError = true;
        this.emailNotValidError = false;
        this.otherDomainError = false;
        return;
      }else if(!this.form.email.match(validRegex)) {
        this.emailEmptyError = false;
        this.emailNotValidError = true;
        this.otherDomainError = false;
        return;
      }

      if(localDomain.includes("YAHOO") && !receivedMail.includes("yahoo.com") && !receivedMail.includes("yahoo.co.in") && !receivedMail.includes("yahoo.co.uk") && !receivedMail.includes("yahoo.de") && !receivedMail.includes("yahoo.es") && !receivedMail.includes("yahoo.fr") && !receivedMail.includes("yahoo.it") && receivedMail!="" && receivedMail!=undefined) {
        console.log("emailid not of yahoo type");
        this.emailEmptyError = false;
        this.emailNotValidError = false;
        this.otherDomainError = true;
        return;
      } else if(localDomain.includes("ICLOUD") && !receivedMail.includes("icloud.com") && !receivedMail.includes("me.com") && receivedMail!="" && receivedMail!=undefined) {
        console.log("emailid not of icloud/me type");
        this.emailEmptyError = false;
        this.emailNotValidError = false;
        this.otherDomainError = true;
        return;
      }else if(localDomain.includes("T-ONLINE") && !receivedMail.includes("t-online.de") && receivedMail!="" && receivedMail!=undefined) {
        this.emailEmptyError = false;
        this.emailNotValidError = false;
        this.otherDomainError = true;
        return;
      }

      return this.form.email ? this.form.email.match(validRegex) : false;
    },
  },
};
</script>
<style scoped>
.overlayClassNoDisplay {
  display: none;
}
.overlayClassDisplay {
  display: block;
}
.redirectCls
{
  margin-top: 3rem;
}
#overlay
{
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
}
#text
{
  position: absolute;
  top: 50%;
  left: 50%;
  font-size: 50px;
  color: white;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
.mt-20 {
  margin-top: 20px;
}
.mb-20 {
  margin-bottom: 20px;
}
.ml-10 {
  margin-left: 10px;
}
.btnsPrntDiv {
  display: flex;
  justify-content: center;
}
h1 {
  font-weight: 500;
  font-size: 2.6rem;
  top: -10px;
}
h3 {
  font-size: 1.2rem;
}
label {
  font-size: 1.2rem;
}
div {
  border-radius: 5px;
}
#error {
  color: red;
}
input[type="email"],
input[type="password"] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
input[type="submit"] {
  width: 30%;
  background-color: #00adef;
  color: white;
  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  cursor: pointer;
}
input[type="submit"]:hover {
  background-color: #00adef;
}
.wrapper {
  padding: 4rem;
}
.sign-in-wrapper {
  margin-top: 40px;
  margin-bottom: 16px
}
.wrapper h1,
.wrapper h3 {
  text-align: center;
}
.wb-button {
  margin-bottom: 15px;
}
.wb-control-error {
  text-align: left;
}
@media (min-width: 1024px) {
  .wrapper {
    padding-left: 30%;
    padding-right: 30%;
  }
  .wrapper h1,
  .wrapper h3 {
    text-align: center;
  }
  .wb-padding-s {
    padding: 0px !important;
    margin-left: -185px !important;
    width: 230% !important;
  }
}
</style>
